export default __webpack_public_path__ + "static/media/bitstop-app-google-store.02916ae8.svg";